module.exports = __webpack_public_path__ + "img/pr-1.801364e9.png";